// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"f02f6bdd","429":"507df505","432":"0cbe5198","507":"b2b04ba4","696":"7ec6d0ef","923":"1dc20a30"}[chunkId] + ".chunk.js";
};